import styles from "./AiInsights.module.css";

export default function TestPager({ items, activeIndex, onSelect, light }) {
  return (
    <div
      className={`${styles.testPager} ${light ? styles.testPagerLight : ""}`}
    >
      <div className={styles.testLabel}>{items[activeIndex]?.skill}</div>
      <div className={styles.testDots}>
        {items?.map((item, i) => (
          <button
            key={item?.skill}
            type="button"
            className={`${styles.testDot} ${i === activeIndex ? styles.testDotActive : ""}`}
            aria-label={item?.skill}
            onClick={() => onSelect(i)}
          />
        ))}
      </div>
    </div>
  );
}
